
import { ReactNode } from 'react';
import Navigation from './Navigation';
import Breadcrumb from './Breadcrumb';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  showNavigation?: boolean;
}

export default function Layout({ children, showNavigation = true }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {showNavigation && <Navigation />}
      {showNavigation && <div className="h-16"></div>}
      <Breadcrumb />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}
